import { IPageName } from '../../common/types/apiSchema';
import { PathMap } from './paths';

/**
 * Localised URLs for Spain
 */
export const EsPaths: PathMap = {
  [IPageName.collections]: ['/:filterslug/filtro'],
  [IPageName.bookingsPage]: ['/reservas'],
  [IPageName.bookingDetailsPage]: ['/reservas/:bookingId/details'],
  [IPageName.cancellationPage]: ['/reservas/:bookingId/cancellation'],
  [IPageName.instantAccess]: ['/accesso-istantaneo/:affiliate'],
};
